<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2091 2.40002H3.84758C3.06422 2.40002 2.3999 3.01903 2.3999 3.78166V20.2176C2.3999 20.981 2.83613 21.6 3.61872 21.6H19.981C20.7643 21.6 21.5999 20.981 21.5999 20.2176V3.78166C21.5999 3.01903 20.9932 2.40002 20.2091 2.40002ZM9.71433 9.71446H12.2987V11.0316H12.3271C12.7211 10.3212 13.8853 9.60002 15.3238 9.60002C18.0855 9.60002 18.8566 11.0669 18.8566 13.7826V18.8567H16.1141V14.2825C16.1141 13.0668 15.6287 11.9993 14.4928 11.9993C13.1143 11.9993 12.4569 12.9324 12.4569 14.4653V18.8567H9.71433V9.71446ZM5.1432 18.8575H7.88573V9.71446H5.14243V18.8575H5.1432ZM8.22825 6.5142C8.22825 7.46038 7.46102 8.22838 6.51485 8.22838C5.56867 8.22838 4.80067 7.46114 4.80067 6.51497C4.80067 5.56879 5.5679 4.80079 6.51408 4.80079C7.46025 4.80079 8.22825 5.56802 8.22825 6.5142Z"
      fill="currentColor"
    />
  </svg>
</template>
